import {securityLink, SecurityLink} from "./link/SecurityLinkComponents";
import {tradeEquityButton, TradeEquityButton} from "./trade/TradeEquityButtonComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(SecurityLink, securityLink())
                  .component(TradeEquityButton, tradeEquityButton())
                  .name;
}
